import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import BaseTimelineCard from '@ts-core/components/Timeline/BaseTimelineCard';

import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

import styles from './timelinePracticeCardStyles';

const useStyles = makeStyles(styles);

const TimelinePracticeCard = (props) => {
  const classes = useStyles();
  const { onPractice } = props;

  const { course = {}, user, availableExercisesCount } = props;
  const { professor = {}, academy = {} } = course;

  return (
    <BaseTimelineCard title={professor.name} subtitle={academy.name}>
      <div className={classes.titleContainer}>
        <FitnessCenterIcon />
        <Typography variant="body1" display="inline" style={{ marginLeft: 8 }}>
          <FormattedMessage
            id="timeLine.practiceCard.availableExercises"
            values={{
              userName: user.name,
              value: availableExercisesCount,
              strong: (chunk) => <strong>{chunk}</strong>,
            }}
          />
        </Typography>
      </div>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button onClick={onPractice} color="secondary">
            <FormattedMessage id="practice" />
          </Button>
        </Grid>
      </Grid>
    </BaseTimelineCard>
  );
};

TimelinePracticeCard.propTypes = {
  course: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  availableExercisesCount: PropTypes.number.isRequired,

  onPractice: PropTypes.func.isRequired,
};

export default TimelinePracticeCard;
